import RegistreNonConformites from '@/views/tableau-de-bord/registre-non-conformites'

// LAB-UI-2 : page « Registre des non-conformités » du laboratoire (menu latéral), qui héberge le bloc du lot 8.
export default {
    name: 'laboratoire-non-conformites',
    components: { RegistreNonConformites },
    props: [],
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}
